import { mapperModuleMedia, mapperModuleNavigationLink } from '../../../core/data-layer/modules/mappers'
import { mapperBlockCallToAction } from '../../../core/data-layer/blocks/mappers'
import { getRelatedPaymentMethods } from '../../../core/data-layer/utils/mappers/pages'
import type { MapperOptions, ModuleMedia } from '#layers/core/types'
import imageSizes from '../../../core/constants/imageSizes'

/**
 * Page content payment methods guides region mapper
 * normalizes data to be used in pages
 */
export default (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }

  const paymentMethodsOverviewLink = options.labels?.paymentMethodsOverviewLink || {}
  const contactSalesLink = options.labels?.contactSalesLink
  const imageSizesForCountries = imageSizes.columns6_11

  return {
    labels: {
      readMore: options.labels?.readMore || '',
      onThisPage: options.labels?.onThisPage || ''
    },
    paymentMethodsOverviewLink: mapperModuleNavigationLink(paymentMethodsOverviewLink, options.getUrl),
    contactSalesLink: mapperModuleNavigationLink(contactSalesLink, options.getUrl),
    subtitle: data.subtitle || '',
    regionName: data.region.name,
    regionId: data.region?.sys?.id || '',
    image: mapperModuleMedia(data?.image, options.imageOptions) as ModuleMedia,
    callToAction: mapperBlockCallToAction(data.callToAction, options.getUrl),
    countryPages: data.countryPages?.items
      ? data.countryPages.items.filter(Boolean).map((item) => {
          const relatedPaymentMethods = getRelatedPaymentMethods(
            item.channelOnlineCollection?.items || [],
            item?.channelInPersonCollection?.items || [],
            5
          )
          return {
            name: item.name || '',
            countryName: item.countryName?.name || '',
            shortDescription: item.shortDescription,
            image: mapperModuleMedia(item.image, {
              resize: true,
              sizes: imageSizesForCountries,
              lazy: true
            }) as ModuleMedia,
            url: options.getInternalUrl(item.sys?.id),
            relatedPaymentMethods
          }
        })
      : []
  }
}
